export const utilMappers = {
  normalize(string) {
    return string
      .toLowerCase()
      .replace(/\s/g, "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }
};
